var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "a",
    {
      class: [
        "dropdown-item",
        { "d-flex align-items-center help-dropdown-item": _vm.hasIcon },
      ],
      attrs: { href: _vm.href, target: _vm.target, rel: _vm.relValue },
    },
    [
      _vm.hasIcon
        ? _c("font-awesome-icon", {
            staticClass: "help-item-icon flex-shrink-0",
            attrs: { icon: _vm.icon, "fixed-width": "" },
          })
        : _vm._e(),
      _vm.description
        ? _c("span", [
            _c("span", { staticClass: "d-block" }, [_vm._v(_vm._s(_vm.title))]),
            _c("small", { staticClass: "text-muted" }, [
              _vm._v(_vm._s(_vm.description)),
            ]),
          ])
        : [_vm._v(_vm._s(_vm.title))],
      _vm.isExternal
        ? _c("font-awesome-icon", {
            class: [
              "external-link-icon",
              "text-muted",
              _vm.hasIcon ? "ml-auto flex-shrink-0" : "ml-1",
            ],
            attrs: { icon: ["fas", "external-link-alt"] },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }